import { IJsonQuery } from '@cian/api-models/common/json_query';
import { IGeoSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { getAreaText } from './getAreaText';
import { getCozy } from './getCozy';
import { getPriceText } from './getPriceText';
import { getSubwayStations } from './getSubwayStations';
import { getTrapRegionsText } from './GetTrapRegionsText';
import { hasArea } from './hasArea';
import { hasPrice } from './hasPrice';
import { isCozyOfferType } from './isCozyOfferType';
import { isPlaceForOfferType } from './isPlaceForOfferType';
import { isRent } from './isRent';
import { isSubwayAdded } from './isSubwayAdded';
import { getDealType, getOfferType } from './jsonQuery';
import { offerTypeLabel } from './offerTypeLabel';

/**
 * Формирует текст для ловушки спроса на основе поискового запроса.
 */
export function getDemandTrapText(geo: IGeoSchema, jsonQuery: IJsonQuery | null): string {
  let text = 'Оставьте заявку, и риэлторы подберут';

  // Если jsonQuery совсем не пришел, то возвращается пустая строка
  if (!jsonQuery) {
    return text.concat(' подходящую вам недвижимость');
  }

  const { undergrounds } = geo;
  const dealType = getDealType(jsonQuery);
  const offerType = getOfferType(jsonQuery);

  // Если пользователь ищет аренду "Квартиры", "Комнаты", "Дома", "Таунхаусы" или "Офисы",
  // то пишем в текст "уютный/уютную"
  if (isRent(dealType) && isCozyOfferType(offerType)) {
    text = text.concat(` ${getCozy(offerType)}`);
  }

  // При отмеченном фильтре "Бытовые услуги" или "Общепит" или "Производство"
  // или "Автосервис", или "Готовый бизнес" формируем фразу "...подберут
  // помещение под ..."
  if (isPlaceForOfferType(offerType)) {
    text = text.concat(` помещение под`);
  }

  // тип недвижимости - квартира/комната и тд
  text = text.concat(` ${offerTypeLabel[offerType]}`);

  // если есть цена, то формируем строку с ценой
  if (hasPrice(jsonQuery)) {
    text = text.concat(` ${getPriceText(jsonQuery)},`);
  }

  // если указана площадь, то добавляем текст с площадью
  if (hasArea(jsonQuery)) {
    text = text.concat(` ${getAreaText(jsonQuery)},`);
  }

  // если выбрано метро, добавляем метро
  if (isSubwayAdded(undergrounds)) {
    text = text.concat(` ${getSubwayStations(undergrounds)}`);
  }

  // добавляем районы: выбранный город + выбранные гео
  text = text.concat(getTrapRegionsText(geo));

  return text;
}
